/**
 * Maps a public path on a creator subdomain/custom domain to the internal SPA path
 * used by `Routes` (`/:username`, `/embed/:username`, etc.).
 */
export function spoofCreatorHostPath(
  pathname: string,
  creatorSlug: string,
): string {
  const p = pathname || "/";
  const slug = String(creatorSlug || "").trim();
  if (!slug) return p;

  if (p === "/") return `/${slug}`;

  const embedPrefix = "/embed";
  if (p === embedPrefix || p === `${embedPrefix}/`) {
    return `${embedPrefix}/${slug}`;
  }
  if (p.startsWith(`${embedPrefix}/`)) {
    if (
      p === `${embedPrefix}/${slug}` ||
      p.startsWith(`${embedPrefix}/${slug}/`)
    ) {
      return p;
    }
    const tail = p.slice(embedPrefix.length);
    return `${embedPrefix}/${slug}${tail}`;
  }

  const previewPrefix = "/preview";
  if (p === previewPrefix || p === `${previewPrefix}/`) {
    return `${previewPrefix}/${slug}`;
  }
  if (p.startsWith(`${previewPrefix}/`)) {
    if (
      p === `${previewPrefix}/${slug}` ||
      p.startsWith(`${previewPrefix}/${slug}/`)
    ) {
      return p;
    }
    const tail = p.slice(previewPrefix.length);
    return `${previewPrefix}/${slug}${tail}`;
  }

  // Legacy `/website/:user` alias — canonicalize to `/:slug/...`.
  if (p === "/website" || p === "/website/") {
    return `/${slug}`;
  }
  if (p === `/website/${slug}`) {
    return `/${slug}`;
  }
  if (p.startsWith(`/website/${slug}/`)) {
    return `/${slug}${p.slice(`/website/${slug}`.length)}`;
  }
  if (p.startsWith("/website/")) {
    const tail = p.slice("/website".length);
    return `/${slug}${tail}`;
  }

  if (p.startsWith(`/${slug}/`) || p === `/${slug}`) return p;
  return `/${slug}${p}`;
}
